<template>
  <div>
    <b-row
      v-show="!hasChargeGeneral && votingCategories.length != 0"
      class="w-75 aling-items-center mx-auto"
    >
      <b-col cols="12" @click="changeStep(7)">
        <b-alert variant="danger" class="cursor-pointer" show>{{
          "AVERTISSEMENT: Il n'y a pas de charges générales pour ce bâtiment !"
        }}</b-alert>
      </b-col>
    </b-row>
    <b-row class="steps-tunnel w-75">
      <!-- step1 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.Copropriété") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 1 }"
          @click="changeStep(1)"
        >
          1
        </b-button>
      </b-col>
      <b-col class="step-line"></b-col>
      <!-- step2 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.Statut") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 2 }"
          :disabled="!step1ok && isNew"
          @click="changeStep(2)"
        >
          2
        </b-button>
      </b-col>
      <b-col class="step-line"></b-col>
      <!-- step3 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.Majorité") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 3 }"
          :disabled="!step2ok && isNew"
          @click="changeStep(3)"
        >
          3
        </b-button>
      </b-col>
      <b-col class="step-line"></b-col>
      <!-- step4 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.Pouvoirs") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 4 }"
          :disabled="!step3ok && isNew"
          @click="changeStep(4)"
        >
          4
        </b-button>
      </b-col>
      <b-col class="step-line"></b-col>
      <!-- step5 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.Copropriétaires") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 5 }"
          :disabled="!step4ok && isNew"
          @click="changeStep(5)"
        >
          5
        </b-button>
      </b-col>
      <b-col class="step-line"></b-col>
      <!-- step6 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ "Contacts & Invités" }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 6 }"
          :disabled="!step5ok && isNew"
          @click="changeStep(6)"
        >
          6
        </b-button>
      </b-col>
      <b-col class="step-line"></b-col>
      <!-- step7 btn -->
      <b-col cols="auto step-btn-block">
        <div class="step-text">{{ $t("general.general_charges") }}</div>
        <b-button
          class="button btn-step"
          :class="{ 'btn-step-active': currentStep == 7 }"
          :disabled="!step6ok && isNew"
          @click="changeStep(7)"
        >
          7
        </b-button>
      </b-col>
    </b-row>
    <!-- .. -->
    <div v-if="!isLoadingInit">
      <appStep1
        v-if="currentStep == 1"
        ref="step-1"
        :building="building"
        @updateBuilding="updateBuilding"
      />
      <appStep2
        v-if="currentStep == 2"
        ref="step-2"
        :building="building"
        @updateBuilding="updateBuilding"
        @updateCoOwnership="updateCoOwnership"
      />
      <appStep3
        v-if="currentStep == 3"
        ref="step-3"
        :building="building"
        :majorities-options="majoritiesOptions"
        :building-majorities="buildingMajorities"
        @updateBuilding="updateBuilding"
        @updateBuildingMajorities="updateBuildingMajorities"
      />
      <appStep4
        v-if="currentStep == 4"
        ref="step-4"
        :building="building"
        @updateBuilding="updateBuilding"
      />
      <appStep5
        v-if="currentStep == 5"
        :building="building"
        :building-id="building.id"
        @hideParentActionButtons="hideActionButtons = $event"
        @updateBuilding="updateBuilding"
      />
      <appStep6
        v-if="currentStep == 6"
        ref="step-6"
        :building="building"
        @hideParentActionButtons="hideActionButtons = $event"
        @updateVotingCategory="updateVotingCategory"
      />
      <appStep7
        v-if="currentStep == 7"
        ref="step-7"
        :building="building"
        @updateVotingCategory="updateVotingCategory"
      />

      <!-- cancel, create, update -->
      <b-row v-if="!hideActionButtons" class="mt-5 mb-2 justify-content-center">
        <b-col cols="auto">
          <b-button class="button btn-red" @click="cancel">
            <font-awesome-icon class="agv-button-icon" icon="times-circle" />
            <span>{{ $t("general.cancel") }}</span>
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            v-if="isNew && currentStep == 4 && !step4ok"
            class="button btn-blue"
            :disabled="isLoadingSave"
            @click="goToNextStep"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="arrow-right" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.enregistrer_and_continue") }}</span>
          </b-button>
          <b-button
            v-else-if="isNew && currentStep !== 7"
            class="button btn-blue"
            :disabled="isLoadingSave"
            @click="goToNextStep"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="arrow-right" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.continue") }}</span>
          </b-button>
          <b-button
            v-else
            :disabled="isLoadingSave"
            class="button btn-blue"
            @click="UPDATE_BUILDING"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.enregistrer") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <appLoader v-else />
  </div>
</template>

<script>
import { validate } from "vee-validate";
import { mapState } from "vuex";

import appStep1 from "./Step1";
import appStep2 from "./Step2";
import appStep3 from "./Step3";
import appStep4 from "./Step4";
import appStep5 from "./Step5";
import appStep6 from "./Step6";
import appStep7 from "./Step7";

import BuildingMW from "@/middlewares/Building";
import BuildingORM from "@/store/orm-axios/models/Building";

import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
import BuildingMajoritiesORM from "@/store/orm-axios/models/BuildingMajorities";

import MajorityMW from "@/middlewares/Majority";
import MajorityORM from "@/store/orm-axios/models/Majority";
import BuildingMajoritiesMW from "@/middlewares/BuildingMajorities";

import { defaultSansVoteMajorityId } from "@/constants/default.js";

export default {
  components: {
    appStep1,
    appStep2,
    appStep3,
    appStep4,
    appStep5,
    appStep6,
    appStep7,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentStep: 1,
      step1ok: false,
      step2ok: false,
      step3ok: false,
      step4ok: false,
      step5ok: false,
      step6ok: false,
      step7ok: false,
      hideActionButtons: false,
      isLoadingInit: true,
      isLoadingSave: false,
      building: {
        agency_id: Number(localStorage.getItem("agencyId")),
        name: "",
        address: "",
        co_ownership: this.$route.path.includes("asl") ? 0 : 1,
        with_majority: 1,
        article22: 1,
        majority_parts: null,
        with_majority_text: "",
        voting_limit: this.$route.path.includes("asl") ? 0 : 1,
        votes_per_mandate: 3, // DEFAULT
        voting_limit_operator: 2, // DEFAULT
        voting_includes_mandates: 1, // DEFAULT
        parts_per_mandate: 10, // DEFAULT
        asl: this.$route.path.includes("asl") ? 1 : 0,
        aful: 0,
        legal: "",
        building_owners: [],
        building_lots: [],
        // voting_categories: [],
        // media_id: ... ???: ??
      },
      existentBuildingMajorities: [],
      buildingMajorities: [],
      votingCategorySelected: false,
      allowSetDefaultMajoritiesOnStep3: true,
      defaultSansVoteMajorityId,
    };
  },
  computed: {
    votingCategories() {
      return VotingCategoryORM.query()
        .where("building_id", this.building.id)
        .withAllRecursive(2)
        .get();
    },
    hasChargeGeneral() {
      let result = false;
      this.votingCategories.forEach(votingRight => {
        if (votingRight.is_charge_generale == 1) {
          result = true;
        }
      });
      /*
       * If a voting category is selected in step 6 votingCategorySelected will be true and vuex will come here
       * Vuex will do two requests, all votingCategories will be charge general 0 and then the selected one will be charge general 1, or vice-versa
       * This will prevent to show the warning message when all charge general will be 0 because we know that a checkbox is selected (votingCategorySelected = true)
       */
      if (this.votingCategorySelected && !result) {
        return true;
      } else {
        return result;
      }
    },
    majoritiesOptions() {
      return MajorityORM.query()
        .where(item => {
          return item.agency_id == this.agencyId || item.id == this.defaultSansVoteMajorityId;
        })
        .get();
    },
    buildingMajoritiesComputed() {
      return BuildingMajoritiesORM.query()
        .where("agency_id", this.agencyId)
        .where("building_id", this.building.id)
        .get();
    },
  },
  async created() {
    if (this.$route.params.step) {
      this.currentStep = this.$route.params.step;
    }

    if (!this.isNew) {
      await BuildingMW.GET(this.$route.params.id)
        .then(res => {
          this.isLoadingInit = false;
          this.building = BuildingORM.query()
            .where("id", this.$route.params.id)
            .withAllRecursive()
            .first();
        })
        .catch(err => {
          this.isLoadingInit = false;
          console.log("error", err);
        });
    } else {
      this.isLoadingInit = false;
    }

    await MajorityMW.FETCH();
    if (this.building.id) {
      await BuildingMajoritiesMW.FETCH(this.building.id);
      // NOTE: Set buildingMajorities values from building-majority relation
      this.buildingMajoritiesComputed.forEach(buildingMajority => {
        const majority = MajorityORM.find(buildingMajority.majority_id);
        this.buildingMajorities.push(majority);
      });
    }
  },
  mounted() {
    // EX: position steps tunnel texts
    this.setStepTextsStyles();
  },
  beforeDestroy() {
    VotingCategoryORM.deleteAll();
    BuildingMajoritiesORM.deleteAll();
  },
  methods: {
    updateBuilding(key, value) {
      this.building[key] = value;
    },
    updateBuildingMajorities(value) {
      this.buildingMajorities = value;
    },
    updateCoOwnership(value) {
      if (this.isNew && value && this.allowSetDefaultMajoritiesOnStep3) {
        this.setDefaultMajoritiesOnStep3();
      }
    },
    async validateStep() {
      var valid = true;
      if (this.currentStep == 1) {
        await validate(this.building.name, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-1"].$refs["vee-building-name"].validate();
          }
        });
      }
      if (this.currentStep == 2) {
        await validate(this.building.legal, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-2"].$refs["vee-building-legal"].validate();
          }
        });
      }
      if (this.currentStep == 3 && !!this.building.with_majority && !this.building.article22) {
        await validate(this.building.majority_parts, "required|min_value:0|max_value:100", {}).then(
          res => {
            if (!res.valid) {
              valid = false;
              this.$refs["step-3"].$refs["vee-building-majority-parts"].validate();
            }
          }
        );
      }
      if (this.currentStep == 4 && !!this.building.voting_limit) {
        await validate(this.building.votes_per_mandate, "required|min_value:0", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-4"].$refs["vee-building-votes-per-mandate"].validate();
          }
        });
        await validate(
          this.building.parts_per_mandate,
          "required|min_value:0|max_value:100",
          {}
        ).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-4"].$refs["vee-building-parts-per-mandate"].validate();
          }
        });
      }
      if (this.currentStep == 7) {
        valid = false;
        if (this.votingCategories.length == 0) {
          valid = true;
        } else {
          valid = this.hasChargeGeneral;
        }
        if (!valid) {
          this.$refs["step-7"].$refs["building-step-7-charges-generales"].validate();
        }
      }
      return valid;
    },
    async changeStep(stepNb) {
      if (!(await this.validateStep())) {
        return;
      }

      this.currentStep = stepNb;
    },
    async goToNextStep() {
      if (!(await this.validateStep())) {
        return;
      }

      if (this.currentStep == 4 && !this.building.id) {
        this.CREATE_BUILDING();
      } else {
        if (this.currentStep == 1) this.step1ok = true;
        if (this.currentStep == 2) this.step2ok = true;
        if (this.currentStep == 3) this.step3ok = true;
        if (this.currentStep == 4) this.step4ok = true;
        if (this.currentStep == 5) this.step5ok = true;
        if (this.currentStep == 6) this.step6ok = true;
        if (this.currentStep == 7) this.step7ok = true;
        this.currentStep++;
      }
    },
    cancel() {
      this.$router.push({ name: "buildings" });
    },
    async CREATE_BUILDING() {
      this.isLoadingSave = true;
      BuildingMW.POST(this.building)
        .then(res => {
          this.updateMajoritiesBuildingId(res.id);

          this.isLoadingSave = false;
          this.building = BuildingORM.query().where("id", res.id).withAllRecursive().first();
          this.$bvToast.toast(this.$t("buildings.building_created_successfully"), {
            title: this.$t("buildings.building_created"),
            variant: "success",
            solid: true,
          });
          this.goToNextStep();
        })
        .catch(err => {
          this.isLoadingSave = false;
          console.log("err", err);
        });
    },
    async UPDATE_BUILDING() {
      if (!(await this.validateStep())) {
        return;
      }

      this.isLoadingSave = true;
      BuildingMW.PUT(this.building)
        .then(res => {
          this.updateMajoritiesBuildingId(res.id);

          this.isLoadingSave = false;
          this.$router.push({ name: "buildings" });
        })
        .catch(err => {
          this.isLoadingSave = false;
          console.log("err", err);
        });
    },
    updateVotingCategory(ev) {
      // Check ev == false instead of doing !ev because when ev is undefined will enter in if(!ev)
      if (ev == false) {
        this.votingCategorySelected = false;
      } else {
        this.votingCategorySelected = true;
      }
    },
    updateMajoritiesBuildingId(buildingId) {
      const bulkMajorities = [];
      this.buildingMajorities.forEach(majority => {
        bulkMajorities.push(majority.id);
      });

      BuildingMajoritiesMW.ADD_BULK_MAJORITIES({
        building_id: buildingId,
        bulk_majorities: bulkMajorities,
        agency_id: this.agencyId,
      });
    },
    setDefaultMajoritiesOnStep3() {
      // NOTE: This case is when building is new and step2 co_ownership = true
      this.allowSetDefaultMajoritiesOnStep3 = false;
      this.buildingMajorities = [];
      this.majoritiesOptions.forEach(majority => {
        if (majority.is_general) {
          this.buildingMajorities.push(majority);
        }
      });
    },
  },
};
</script>
